import queryString from 'query-string';
import { useEffect, useRef } from 'react';

import {
  useClientEnvironment,
  useUser,
  useUserEnvironmentActions,
} from '#/contexts/UserEnvironmentContext';

export function OverrideABExperimentsWithUrlParamsGlobalHandler() {
  const { user } = useUser();
  const { clientEnvironment } = useClientEnvironment();
  const { setABExperimentBucket, setUserEnvironment } =
    useUserEnvironmentActions();

  const triggeredRef = useRef(false);

  useEffect(() => {
    if (!clientEnvironment || triggeredRef.current) return;
    triggeredRef.current = true;

    const queryParams = queryString.parse(window.location.search);
    const overrides = Object.keys(queryParams).reduce((acc, param) => {
      const matches = /^ab_test\[([^\]]+)\]$/.exec(param);

      if (matches) {
        // @ts-expect-error TS(2322): Type 'string' is not assignable to type 'never'.
        acc.push({ id: matches[1], bucket: queryParams[param] });
      }

      return acc;
    }, []);

    overrides.forEach(({ id, bucket }) => {
      const experiment = clientEnvironment.abExperiments.find(
        (e) => e.id === id,
      );

      if (experiment?.bucket !== bucket) {
        void setABExperimentBucket(id, bucket);
      }
    });
  }, [clientEnvironment, setABExperimentBucket, setUserEnvironment, user]);

  return null;
}
